import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import React, { memo } from 'react';
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import CatalogFilter from './CatalogFilter';
import Row from '@amzn/meridian/row';
import Link from '@amzn/meridian/link';

interface FilterSectionProps {
  filters: {
    language: string;
    metric: string;
    duration: string;
  };
  setFilters: (filters: any) => void;
  selections: {
    language: string[];
    metric: string[];
    duration: string[];
  };
  onReset: () => void;
}

export const FilterSection: React.FC<FilterSectionProps> = memo(
  ({ filters, setFilters, selections, onReset }) => {
    const intl = useIntl();
    return (
      <Box type='outline' spacingInset='400' minHeight={90}>
        <Column spacingInset={'none none 400'}>
          <Text type='h200'>
            <FormattedMessage
              id='cs_perfportal_filterBy'
              defaultMessage='Filter by'
            />
          </Text>
        </Column>

        <Column spacingInset={'none none 400'}>
          <CatalogFilter
            filterLabel={intl.formatMessage({
              id: 'cs_perfportal_training_catalog_language',
              defaultMessage: 'Language',
            })}
            value={filters.language}
            setValue={language => setFilters(prev => ({ ...prev, language }))}
            selections={selections.language}
            isLanaguageCode
          />
        </Column>

        <Column spacingInset={'none none 400'}>
          <CatalogFilter
            filterLabel={intl.formatMessage({
              id: 'cs_perfportal_training_catalog_ccx_metric',
              defaultMessage: 'CCX metric',
            })}
            value={filters.metric}
            setValue={metric => setFilters(prev => ({ ...prev, metric }))}
            selections={selections.metric}
          />
        </Column>

        <Column spacingInset={'none none 600'}>
          <CatalogFilter
            filterLabel={intl.formatMessage({
              id: 'cs_perfportal_training_catalog_duration',
              defaultMessage: 'Duration',
            })}
            value={filters.duration}
            setValue={duration => setFilters(prev => ({ ...prev, duration }))}
            selections={selections.duration}
            isDuration
          />
        </Column>

        <Row alignmentHorizontal='center'>
          <Link onClick={onReset}>
            <FormattedMessage
              id='cs_perfportal_filter_reset'
              defaultMessage='Reset filters'
            />
          </Link>
        </Row>
      </Box>
    );
  }
);
